import { FlexLayout } from '@deity/falcon-ui';
import type { DictDefinition, FieldDefinition, ListDefinition } from '@deity-io/di-data-structure-editor';
import { Collapsible } from 'components/Collapsible';
import { SchemaActionTypes, SchemaContext } from 'contexts/SchemaContext';
import type React from 'react';
import { useContext, useMemo } from 'react';
import AddConstraint from './AddConstraint';
import ConstraintItem from './ConstraintsItem';

type ConstraintsContainerProps = {
  isEditable: boolean;
  path: Array<string>;
  schema: DictDefinition | ListDefinition | FieldDefinition;
};
const ConstraintsContainer: React.FC<ConstraintsContainerProps> = ({ isEditable, schema, path }) => {
  const ctx = useContext(SchemaContext);
  const constraints = schema.config['validators'] || [];

  const constraintsProperties = useMemo(() => {
    const validators = schema.availableValidators();
    const constraintsProps = {};
    validators.forEach(validatorKey => {
      constraintsProps[validatorKey] = schema.getValidatorProperties(validatorKey);
    });

    return constraintsProps;
  }, [schema.config.validators]);

  const updateConstraints = (updatedConstraints: any[]) => {
    ctx?.dispatch({
      type: SchemaActionTypes.UPDATE_SETTING,
      payload: {
        path: [...path],
        property: ['validators'],
        value: updatedConstraints
      }
    });
  };

  const onConstraintChange = (i: number, key: Array<string>, value: string | number | boolean | undefined | {}) => {
    ctx?.dispatch({
      type: SchemaActionTypes.UPDATE_SETTING,
      payload: {
        path: [...path],
        property: ['validators', i.toFixed(), ...key],
        value
      }
    });
  };

  return (
    <Collapsible title="Constraints" itemCount={constraints.length}>
      {isEditable && (
        <AddConstraint
          constraints={schema?.availableValidators()}
          constraintsProperties={constraintsProperties}
          onConstraintAdd={val => updateConstraints([...constraints, { ...val }])}
        />
      )}
      <FlexLayout>
        {constraints.map((constraint, i) => {
          if (!constraint) {
            // eslint-disable-next-line no-console
            console.warn('Invalid constraint in structure.');
          }

          return (
            <ConstraintItem
              key={i} // eslint-disable-line react/no-array-index-key
              validatorProperties={constraintsProperties[constraint.type]}
              persistedValue={constraint}
              owner={schema}
              type={constraint.type}
              index={(i + 1).toString()}
              locked={!isEditable}
              onRemove={index => {
                ctx?.dispatch({
                  type: SchemaActionTypes.UPDATE_SETTING,
                  payload: {
                    path: [...path],
                    property: ['validators', i.toFixed()],
                    value: undefined
                  }
                });
                // return updateConstraints(constraints.filter(p => p !== constraints[parseInt(index, 10) - 1]));
              }}
              onValueChange={(key, value) => {
                onConstraintChange(i, key, value);
              }}
              onDeleteProperty={key => {
                onConstraintChange(i, key, undefined);
              }}
            />
          );
        })}
      </FlexLayout>
    </Collapsible>
  );
};

export default ConstraintsContainer;
